<form-popup [width]="520" [(visible)]="visible" (visibleChange)="onVisibleChange($event)"
            (save)="onPopupSaveClick()"
            (open)="onOpen()"
            [isSaveDisabled]="isReadOnly"
            titleText="Compliance">
    <compliance-form [formData]="formData" [isReadOnly]="isReadOnly"></compliance-form>
</form-popup>
